/* eslint-disable react/jsx-wrap-multilines */
import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import SearchOptions from "Components/SearchOptions";
import { areEqualShallow } from "Utils/areEqual";
import Icon from "Components/Icons";
import { checkIsTrailsEnabled } from "Utils/utils";
import styles from "./styles";

interface Props {
  resetDirections: () => void;
  gotToDestinations: () => void;
  setShowDirections: (showTrails: boolean) => void;
  showDirections: boolean;
  usedSwitcher: any;
  showSwitcher: boolean;
  goToCampusMap: () => void;
  setSearchOptionsView: (
    view: string,
    showSearchOptionsMobile?: boolean
  ) => void;
  trailsCount: number;
}
const SearchOptionsDestinations: FC<Props> = memo(
  ({
    resetDirections,
    showDirections,
    setSearchOptionsView,
    setShowDirections,
    gotToDestinations,
    usedSwitcher,
    showSwitcher,
    goToCampusMap,
    trailsCount,
  }: Props) => {
    const useStyles = createUseStyles(styles);
    const classes = useStyles();
    const view = useSelector((store: any) => store.searchOptionsView.view);
    const goToTrails = () => {
      resetDirections();
      setSearchOptionsView("trails");
    };

    const handleArrowClick = () => {
      if (showDirections) goToTrails();
      else setShowDirections(true);
    };

    const currentLabelClick = () => {
      setShowDirections(!showDirections);
    };

    // End - Desktop/Tablet View Functionality

    // Return seach options, based on whether it's mobile or desktop
    return (
      <>
        {view === "directions" && (
          <SearchOptions
            arrowSlot={
              <Icon
                type="leftarrow"
                events={{
                  onClick:
                    usedSwitcher || !showSwitcher
                      ? handleArrowClick
                      : goToCampusMap,
                }}
              />
            }
            slot1={<Icon type="directions" tabIndex={-1} />}
            textLabel={
              <Icon
                text="Directions"
                type="textLabel"
                events={{
                  onClick: currentLabelClick,
                }}
                className={`${classes.button}`}
              />
            }
            slot2={
              checkIsTrailsEnabled(trailsCount) ? (
                <Icon
                  type="trails"
                  events={{
                    onClick: goToTrails,
                  }}
                />
              ) : null
            }
            slot3={
              <Icon
                type="close"
                events={{
                  onClick:
                    usedSwitcher || !showSwitcher
                      ? gotToDestinations
                      : goToCampusMap,
                }}
              />
            }
          />
        )}
      </>
    );
  },
  areEqualShallow
);

export default SearchOptionsDestinations;
